import {Box, Typography} from '@mui/material'
import {t} from 'i18next'
import {ReactComponent as EmptyIcon} from '../assets/empty.svg'
import {styles} from '../styles'

interface EmptyStateProps {
  title?: string
  description?: string
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = t('orderIntake.rmc.jobSiteModal.create.noAddressFoundTitle'),
  description = t('orderIntake.rmc.jobSiteModal.create.noAddressFoundDescription')
}) => {
  return (
    <Box sx={styles.emptyStateContainer} data-test-id="empty-state-container">
      <Box sx={styles.emptyStateIconContainer} data-test-id="empty-state-icon-container">
        <EmptyIcon width={104} height={67} data-test-id="empty-state-icon" />
      </Box>

      <Typography variant="h6" sx={styles.emptyStateTitle} data-test-id="empty-state-title">
        {title}
      </Typography>

      <Typography
        variant="body2"
        sx={styles.emptyStateDescription}
        data-test-id="empty-state-description"
      >
        {description}
      </Typography>
    </Box>
  )
}
